import { render, staticRenderFns } from "./MissingEmailSenderBanner.vue?vue&type=template&id=2f32b8a2&scoped=true&lang=pug&"
import script from "./MissingEmailSenderBanner.vue?vue&type=script&lang=js&"
export * from "./MissingEmailSenderBanner.vue?vue&type=script&lang=js&"
import style0 from "./MissingEmailSenderBanner.vue?vue&type=style&index=0&id=2f32b8a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32b8a2",
  null
  
)

/* custom blocks */
import block0 from "./MissingEmailSenderBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports